import React from "react"

const SurveyGrowthTab = () => {
	return (
		<div>Tulossa myöhemmin</div>
	)
}

export default SurveyGrowthTab